import { Component, ComponentChildren } from 'preact'
import Icon from '../assets'

interface ConfigurationSectionLabelProps {
  title: string
  children: ComponentChildren
  isExtended?: boolean
}

interface State {
  isExtended: boolean
}

export default class ConfigurationSectionLabel extends Component<ConfigurationSectionLabelProps, State> {
  constructor (props: ConfigurationSectionLabelProps) {
    super(props)

    this.state = {
      isExtended: props.isExtended ?? true
    }
  }

  render({ title, children }: ConfigurationSectionLabelProps, { isExtended }: State) {
    return (
      <div className='widget-configurator_tab homepage-widget-configurator_tab-content'>
        <div className='widget-configurator_tab-header' onClick={() => this.setState({ isExtended: !isExtended })}>
          <div className='widget-configurator_tab-icon'>
            <Icon size={24} color='#2B3346' icon={isExtended ? 'chevronDown' : 'chevronRight'} />
          </div>
          {title}
        </div>
        {
            isExtended && (
              <div className='widget-configurator_tab-content'>
                {children}
              </div>)
        }
      </div>
    )
  }
}
